module.exports = __webpack_public_path__ + "static/media/exit.62eefd11.svg";